import React, { useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Loading from '~/Components/Loading';
import FiltrosSimulacao from './components/FiltrosSimulacao';
import ResultadoSimulacao from './components/ResultadoSimulacao';
import {
  listarCobradores,
  listarEmpreendimentos,
  simular,
} from './services/simulaComissaoCobrancaService';

const FILTROS_INICIAIS = {
  data_inicio: null,
  data_fim: null,
  dias: 0,
  cobrador_id: null,
  familia_id: null,
  analitico: true, // RadioButton1 default
  comissao_por_percentual: true, // Rper default
  calcular_por_faixa: true, // rbFaixa default
  faixas: [],
  valor_fixo_rfg: 0,
  valor_fixo_res: 0,
  valor_fixo_rfp: 0,
};

/**
 * SimulaComissaoCobranca — Pro-Fit > Cobrança > Relatórios > "Simula comissão cobrança".
 * Simulador READ-ONLY de comissão de cobrança com faixas progressivas (porte de USimulaCobrador.pas).
 * RBAC literal: aberto a qualquer autenticado, sem gate de característica (fiel ao ERP).
 */
const SimulaComissaoCobranca = () => {
  const [cobradores, setCobradores] = useState([]);
  const [empreendimentos, setEmpreendimentos] = useState([]);
  const [filtros, setFiltros] = useState(FILTROS_INICIAIS);
  const [resultado, setResultado] = useState(null);
  const [carregandoCombos, setCarregandoCombos] = useState(true);
  const [simulando, setSimulando] = useState(false);

  useEffect(() => {
    let ativo = true;
    (async () => {
      try {
        const [resCobradores, resEmpreendimentos] = await Promise.all([
          listarCobradores(),
          listarEmpreendimentos(),
        ]);
        if (!ativo) return;
        setCobradores(resCobradores || []);
        setEmpreendimentos(resEmpreendimentos || []);
      } catch (err) {
        const msg =
          (err && err.message) || 'Erro ao carregar filtros.';
        toast.error(msg);
      } finally {
        if (ativo) setCarregandoCombos(false);
      }
    })();
    return () => {
      ativo = false;
    };
  }, []);

  const handleSimular = async () => {
    setSimulando(true);
    try {
      const body = {
        data_inicio: filtros.data_inicio,
        data_fim: filtros.data_fim,
        dias: filtros.dias,
        cobrador_id: filtros.cobrador_id,
        familia_id: filtros.familia_id,
        analitico: filtros.analitico,
        comissao_por_percentual: filtros.comissao_por_percentual,
        calcular_por_faixa: filtros.calcular_por_faixa,
        faixas: filtros.faixas,
        valor_fixo_rfg: filtros.valor_fixo_rfg,
        valor_fixo_res: filtros.valor_fixo_res,
        valor_fixo_rfp: filtros.valor_fixo_rfp,
      };
      const res = await simular(body);
      setResultado(res || null);
    } catch (err) {
      const msg = (err && err.message) || 'Erro ao simular comissão.';
      toast.error(msg);
    } finally {
      setSimulando(false);
    }
  };

  const handleCancelar = () => {
    setFiltros(FILTROS_INICIAIS);
    setResultado(null);
  };

  return (
    <Container fluid className="mt-3">
      <Card>
        <Card.Header>
          <h5 className="mb-0">Simula Comissão Cobrança</h5>
        </Card.Header>
        <Card.Body>
          {carregandoCombos ? (
            <div className="text-center my-4">
              <Loading />
            </div>
          ) : (
            <>
              <FiltrosSimulacao
                cobradores={cobradores}
                empreendimentos={empreendimentos}
                filtros={filtros}
                setFiltros={setFiltros}
                onSimular={handleSimular}
                onCancelar={handleCancelar}
                loading={simulando}
              />

              {simulando ? (
                <div className="text-center my-4">
                  <Loading />
                </div>
              ) : (
                <ResultadoSimulacao resultado={resultado} />
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default SimulaComissaoCobranca;
